import React, {useCallback} from "react";
import IconButton from "../../../components/IconButton";
import {faArrowDown, faArrowUp} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import {useCustomizer} from "../../../contexts/CustomizerContext";

const LayerSwitch: React.FC<{unique_id: string}> = ({unique_id}) => {
    const { canvas, setUserInputs } = useCustomizer()
    const { t } = useTranslation(['settings'])

    const changeLayer = useCallback((unique_id: string, dir: 'up'|'down') => {
        const obj = canvas.getObjects().find((o) => {
            return (o.data?.unique_id === unique_id && o.data?.is_clip_path === false)
        });

        setUserInputs(prev => {
            const inputArray = [...prev.entries()].map(([uid, o]) => {
                return {uid, o}
            })
            if (inputArray) {
                const from = inputArray.map((e) => e.uid).indexOf(unique_id)
                const to = (dir === 'up') ? from + 1 : from - 1
                if (to >= 0 && to < inputArray.length) {
                    const element = inputArray.splice(from, 1)[0];
                    inputArray.splice(to, 0, element);
                }
            }

            return new Map(inputArray.map((i) => [i.uid, i.o]))
        })

        if (obj && dir === 'up') {
            canvas.bringForward(obj, true)
        }
        if (obj && dir === 'down') canvas.sendBackwards(obj, true)
    }, [canvas, setUserInputs])

    return (
        <>
            <IconButton
                icon={faArrowUp}
                color={'black'}
                onClick={() => changeLayer(unique_id, 'up')}
                title={t('layer.moveLayerUp')}
            />
            <IconButton
                icon={faArrowDown}
                color={'black'}
                onClick={() => changeLayer(unique_id, 'down')}
                title={t('layer.moveLayerDown')}
            />
        </>
    )
}

export default LayerSwitch
